import React, { useEffect, useState } from 'react';
import Social from '../Social/Social';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';

const Footer = ({ data, varient }) => {
  const { logo, subTitle, bgImg, links } = data;
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const [scrollPosition, setScrollPosition] = useState(0);

  const handleScroll = () => {
    setScrollPosition(window.scrollY);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className={`st-site-footer st-sticky-footer st-dynamic-bg ${varient || ''}`} style={{ backgroundImage: `url(${bgImg})` }}>
      <div className="st-main-footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="st-footer-widget">
                <div className="st-text-field">
                  <img src={logo} alt="Fisioters SAS" className="st-footer-logo" />
                  <div className="st-height-b25 st-height-lg-b25" />
                  <div className="st-footer-text">{subTitle}</div>
                  <div className="st-height-b25 st-height-lg-b25" />
                  <Social data={links} />
                </div>
              </div>
            </div>

            <div className="col-lg-3">
              <div className="st-footer-widget">
                <h2 className="st-footer-widget-title">Enlaces Útiles</h2>
                <ul className="st-footer-widget-nav st-mp0">
                  <li><ScrollLink to="faq" spy={true} duration={500}><Icon icon="fa:angle-right" /> Preguntas Frecuentes</ScrollLink></li>
                  <li><Link to="https://drive.google.com/drive/folders/1hR_FZuy0Es_usC_mQb-BscsVPCor1wQp?usp=sharing"><Icon icon="fa:angle-right" /> Estados Financieros</Link></li>
                  <li><Link to="https://drive.google.com/file/d/1jp0Xck1VhLU7tm6RNUGQGqap3QUEWp4u/view?usp=sharing"><Icon icon="fa:angle-right" />Portafolio de Servicios</Link></li>
                  <li><ScrollLink to="contact" spy={true} duration={500}><Icon icon="fa:angle-right" />PQRFS</ScrollLink></li>
                </ul>
              </div>
            </div>

            <div className="col-lg-3">
              <div className="st-footer-widget">
                <h2 className="st-footer-widget-title">Servicios</h2>
                <ul className="st-footer-widget-nav st-mp0">
                  <li><ScrollLink to="department" spy={true} duration={500}><Icon icon="fa:angle-right" /> Consulta Médica</ScrollLink></li>
                  <li><ScrollLink to="department" spy={true} duration={500}><Icon icon="fa:angle-right" /> Diagnóstico por Imágenes</ScrollLink></li>
                  <li><ScrollLink to="department" spy={true} duration={500}><Icon icon="fa:angle-right" /> Rehabilitación Integral</ScrollLink></li>
                  <li><ScrollLink to="department" spy={true} duration={500}><Icon icon="fa:angle-right" /> Atención Domiciliaria</ScrollLink></li>
                </ul>
              </div>
            </div>

            <div className="col-lg-3">
              <div className="st-footer-widget">
                <h2 className="st-footer-widget-title">Contacto</h2>
                <ul className="st-footer-contact-list st-mp0">
                  <li>
                    <span className="st-footer-contact-title">Dirección:</span>
                    Cl 14 #13-63, Villanueva, <br></br>La Guajira, Colombia
                  </li>
                  <li>
                    <span className="st-footer-contact-title">Email:</span> notificaciones@fisioters.com
                  </li>
                  <li>
                    <span className="st-footer-contact-title">Teléfono:</span> (+57) 320 123 4567
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="st-copyright-wrap">
        <div className="container">
          <div className="st-copyright-in">
            <div className="st-left-copyright">
              <div className="st-copyright-text">
                © {currentYear} Fisioters S.A.S. Todos los derechos reservados.
              </div>
            </div>
            <div className="st-right-copyright">
              <div id="st-backtotop" style={{ scale: `${scrollPosition >= 100 ? '1' : '0'}` }} onClick={scrollToTop}>
                <Icon icon="fa6-solid:angle-up" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
